<template lang="pug">
.ber-form
  BERSearch
  template(v-if="berData")
    HouseInfoForm(v-if="showHouseForm")
    AddressSearch(v-if="addressRequired")
    TermsAgreement(v-if="houseTypologySelected && (addressRequired ? !!addressResult : true)")
</template>

<script lang="ts">
import { computed, defineComponent, ref } from "vue";

import TermsAgreement from "@/components/forms/questions/TermsAgreement.vue";
import BERSearch from "./questions/ber/BERSearch.vue";
import AgeOfHome from "@/components/forms/questions/general/AgeOfHome.vue";
import NumberOfStoreys from "@/components/forms/questions/general/NumberOfStoreys.vue";
import HouseType from "@/components/forms/questions/general/HouseType.vue";
import HouseTypology from "@/components/forms/questions/general/HouseTypology.vue";
import AddressSearch from "./questions/AddressSearch.vue";
import { useSelections, useSettings } from "@/store";
import { storeToRefs } from "pinia";
import HouseInfoForm from "./questions/general/HouseInfoForm.vue";
import { LayoutEvent, on } from "@/helpers";
export default defineComponent({
  name: "BERForm",
  components: {
    TermsAgreement,
    BERSearch,
    AddressSearch,
    AgeOfHome,
    NumberOfStoreys,
    HouseType,
    HouseTypology,
    HouseInfoForm,
  },
  setup() {
    const selections = useSelections();
    const { settings } = storeToRefs(useSettings());
    const addressRequired = computed<boolean>(() => !!settings.value?.autoaddressKey);
    const {
      age,
      storeys,
      houseTypeSelected,
      houseTypologySelected,
      addressResult,
      houseTypes,
      berData,
    } = storeToRefs(selections);

    const isAddressValid = computed<boolean>(() => !!addressResult.value);

    const showHouseForm = ref(false);
    on(LayoutEvent.ShowHouseInfoForm, (val: boolean) => (showHouseForm.value = val));

    return {
      ...storeToRefs(useSelections()),
      addressRequired,
      age,
      storeys,
      houseTypeSelected,
      houseTypes,
      houseTypologySelected,
      isAddressValid,
      berData,
      showHouseForm,
    };
  },
});
</script>

<style lang="scss" scoped></style>
